export default "__VITE_ASSET__BnAbCOqz__"